import { useRef } from "react";

import {
  GraphCMSQueryDef,
  useGraphCMS,
} from "@mywheels/common/lib/useGraphCMS";

import { ArrowRightIcon } from "web/ui/icons/arrows";
import { ExternalLinkIcon } from "web/ui/icons/ExternalLinkIcon";
import { Masonry } from "./Masonry";

type Move = {
  id: string;
  username: string;
  link: string;
  im?: {
    id: string;
    mimeType: string;
    handle: string;
    url: string;
  };
};

const GetMovesQuery: GraphCMSQueryDef<{
  moves: Move[];
}> = {
  query: `
    query Moves {
      moves(orderBy:order_ASC) {
        id
        username
        link
        im {
          id
          mimeType
          handle
          url
        }
      }
    }
  `,
};

export function MoveWall() {
  const { data } = useGraphCMS(GetMovesQuery, {});

  return (
    <div className="-mx-2">
      <Masonry breakpoints={{ 768: 3 }}>
        {data?.moves.map((move) => {
          return <MoveTile key={move.id} move={move} />;
        })}
      </Masonry>
    </div>
  );
}

function MoveTile({ move }: { move: Move }) {
  const videoRef = useRef<HTMLVideoElement>(null);

  if (!move.im || !move.im.mimeType.includes("video/mp4")) {
    console.log("Cannot deal with move mimetype / im does not exist", move);
    return null;
  }

  return (
    <div className="p-2">
      <a
        target="_blank"
        rel="noreferrer"
        href={move.link}
        className="group block relative rounded-md overflow-hidden focus:outline-none transition-transform active:scale-[0.98]"
      >
        <video autoPlay muted loop ref={videoRef} playsInline>
          <source src={move.im.url} type={move.im.mimeType} />
        </video>
        <div className="invisible group-hover:visible group-hover:bg-opacity-50 absolute inset-0 bg-black bg-opacity-0 flex justify-center items-center transition">
          <ArrowRightIcon size={28} color="white" />
        </div>
        <div className="absolute bottom-0 left-0 right-0 text-center text-white p-2 font-display">
          @{move.username} <ExternalLinkIcon />
        </div>
      </a>
    </div>
  );
}
